// extracted by mini-css-extract-plugin
export default {"textarea":"Confirmation_textarea__uW5XE"};